import { Component, ElementRef, OnInit, ViewChild, } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { DatePipe } from '@angular/common';

import { ajax } from 'rxjs/ajax';

import { environment } from 'src/environments/environment';

import { OtherService } from 'src/app/Service/other.service';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { InfiniteScrollService } from '../infinite-scroll/service/infinite-scroll.service';

import axios from 'src/app/Service/axios';

import { NotificationService } from 'src/app/Service/notification.service';

@Component({

  selector: 'app-news',

  templateUrl: './news.component.html',

  styleUrls: ['./news.component.css']

})

export class NewsComponent implements OnInit {

  Info: any;

  news: any = [];

  news_Temp: any = [];

  newsDetail: any;

  modeRead: boolean = false;

  bDataEnded: boolean = false;

  bScrollLoading: boolean = false;

  isResultLoading: boolean = false;

  bUpButton: boolean = false;

  webAppName = (<any>window).webAppName;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iPage: new FormControl('-1'),

    iTotal: new FormControl('-1'),

    tiType: new FormControl('-1'),

  })

  @ViewChild('point_1', { static: false }) private my_point_1!: ElementRef;

  constructor(

    private otherService: OtherService,

    private toastr: ToastrService,

    private route: ActivatedRoute,

    private FormBuilder: FormBuilder,

    private _InfiniteScrollService: InfiniteScrollService,

    private _otherService: OtherService,

    private gurdService: GurdServiceService,

    private notification: NotificationService

  ) { }

  ngOnInit(): void {

    this.route?.url?.subscribe((segment) => {

      this.modeRead = segment[1]?.path ? true : false;

      if (this.modeRead) {

        let iNews: number | string = segment[1]?.path;

        this.getNews(iNews);

      }

      else {

        this.otherService.setTitle(`${this.webAppName} | مدیریت ناوگان، مشخصات ردیاب و نکات ایمنی`)

        this.getListNews();

        // listen to user scroll activity

        this._InfiniteScrollService.isScrollToBottom$.subscribe((isScrollBottom: boolean) => {

          if (isScrollBottom && !this.bDataEnded && this.news.length && !this.isResultLoading) {

            this.loadMoreData();

          }

        });

        this._InfiniteScrollService.isDataEnded$.subscribe((isEnded: boolean) => {

          if (isEnded) {

            this.bScrollLoading = false;

            this.bDataEnded = true;

          }

        });

      }

    });

  }

  ngOnDestroy() {

    this.otherService.setTitle('');

    this._InfiniteScrollService.update_DataStatus(false);

  }

  getListNews = async () => {

    let iPage = this.otherService.stringNumberToNumber(this.mdl_Search.get('iPage')?.value);

    this.otherService.Showspinner();

    const response = await axios.post(`TaxilLon_News_List?iPage=${iPage}`, {});

    this.otherService.nonespinner();

    this.news = JSON.parse(response.data.toString());

    this.news_Temp = this.news;

    this.mdl_Search.controls['iTotal'].setValue(this.news.length ? this.news[0].iTotal : '0');

    this._InfiniteScrollService.update_DataStatus(false);

    this.bDataEnded = false;


  }

  getNews = async (iNews: number | string) => {

    this.otherService.Showspinner();

    const resp = await axios.post(`TaxiLon_News_Info?iNews=${iNews}`, {});

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data.toString());

    this.newsDetail = res[0];

    this.otherService.setTitle(` ${this.webAppName} | ${this.newsDetail.strTitle}`)

  }

  subString_Title(text: string, limit?: number) {

    if (limit && text?.length > limit) text = text.slice(0, limit) + '...';

    if (!limit && text?.length > 55) text = text.slice(0, 55) + '...';

    return text;

  }

  loadMoreData() {

    if (this.news.length == this.mdl_Search.get('iTotal')?.value) {

      this._InfiniteScrollService.update_DataStatus(true);
    }

    else {

      this.bScrollLoading = true;

      setTimeout(() => {

        this.mdl_Search.get('iPage')?.setValue(this.news[this.news.length - 1].iPage);

        this.sendDataToApi();

      }, 600);

    }

  }

  sendDataToApi() {

    this.isResultLoading = true;

    ajax.post((<any>window).baseUrl + `TaxilLon_News_List?iPage=${this.mdl_Search.value.iPage}`, this._otherService.stringNumberToNumber(this.mdl_Search.value), {

      'Content-Type': 'application/json',

    }).subscribe({

      next: (value: any) => {

        this.isResultLoading = false;

        this.bScrollLoading = false;

        let res = JSON.parse(value.response);

        if (res.bError) {

          this.isResultLoading = false;

          this._InfiniteScrollService.update_DataStatus(true);

          return this.notification.showError(res.strError);

        }

        if (!res.length) {

          this.isResultLoading = false;

          this._InfiniteScrollService.update_DataStatus(true);

          return this.notification.showError('موردی یافت نشد');

        }

        this.news = this.news.concat(res);

        this.news_Temp = this.news;

        this.mdl_Search.get('iTotal')?.setValue(this.news[0].iTotal);

        // if "iPage" is Equal to 0 , Stop gathering data

        if (res[res.length - 1].iPage == 0) {

          this._InfiniteScrollService.update_DataStatus(true);

        }

      },

      error: (err) => {

        this.notification.showError('لطفا وضعیت اتصال اینترنت خود را بررسی کنید');

        this.isResultLoading = false;

        this._InfiniteScrollService.update_DataStatus(true);

      },

    });

  }

  gotoTop() {

    this.my_point_1.nativeElement.scrollIntoView({

      behavior: 'smooth',

    });

    setTimeout(() => {

      this.bUpButton = false;

    }, 1000);

  }

  openNews(iNews: number) {

    window.open(`/news/${iNews}`, '_blank');

  }

  search_News(strValue: string) {

    // if (strValue.length > 1) {

    //   this.news = this.news_Temp.filter((el: any) => {

    //     return el.strTitle.includes(strValue)

    //   })

    // }

    // else if (strValue == '') this.news = this.news_Temp;

  }

}
